module.exports = {"431129100":"沱江镇","431129103":"大路铺镇","431129104":"白芒营镇","431129105":"涛圩镇","431129106":"河路口镇","431129108":"大圩镇","431129109":"水口镇","431129110":"码市镇","431129111":"涔天河镇","431129200":"界牌乡","431129201":"桥市乡","431129202":"大石桥乡","431129207":"湘江乡","431129209":"蔚竹口乡","431129210":"大锡乡","431129211":"小圩壮族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431129.json
// module id = 1913
// module chunks = 0